<span
  class="group relative inline-flex items-center self-center align-middle"
  [style.--tooltip-hover-delay]="hoverDelayMs() + 'ms'">
  @if (showIcon()) {
    <span
      tabindex="0"
      class="material-symbols-rounded text-primary-main cursor-pointer text-xl! leading-none font-normal"
      [attr.aria-label]="ariaLabel()">
      help
    </span>
  }
  <ng-content />
  <span
    role="tooltip"
    class="pointer-events-none absolute top-full z-30 mt-2 w-max max-w-80 rounded-md bg-primary-off px-3 py-2 text-sm font-normal whitespace-normal text-standard-background opacity-0 shadow-md transition-opacity delay-0 group-hover:opacity-100 group-hover:delay-[var(--tooltip-hover-delay)]"
    [ngClass]="{
      'left-0': horizontalAlignment() === 'left',
      'left-1/2 -translate-x-1/2': horizontalAlignment() === 'center',
      'right-0': horizontalAlignment() === 'right',
    }">
    {{ text() }}
  </span>
</span>
